// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__pzY+A","viewItemValue":"view-form_viewItemValue__69Uv1"};